import styled from "styled-components"

export const ContainerMain = styled.div`
    width: 100%;
    height: auto;
`